import React, { useState } from "react";
import "./Publisher.scss";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import LogicModal from "../../Components/LogicModal/LogicModal";

const dummyCoins = [
  {
    name: "Bitcoin Cash",
    price: "555.75",
    change: "+4.85 (0.78%)",
    date: "July 21, 2023, 03:30 PM ITS",
  },
  {
    name: "AVAX",
    price: "555.75",
    change: "+4.85 (0.78%)",
    date: "July 21, 2023, 03:30 PM ITS",
  },
  {
    name: "AVAX",
    price: "555.75",
    change: "+4.85 (0.78%)",
    date: "July 21, 2023, 03:30 PM ITS",
  },
  {
    name: "AVAX",
    price: "555.75",
    change: "+4.85 (0.78%)",
    date: "July 21, 2023, 03:30 PM ITS",
  },
];

function Card({ coin }) {
  const [opinion, setOpinion] = useState("long");
  const [entryType, setEntryType] = useState("market");

  const [entry, setEntry] = useState("");
  const [target1, setTarget1] = useState("");
  const [target2, setTarget2] = useState("");
  const [stoploss, setStoploss] = useState("");
  const [leverage, setLeverage] = useState("");

  const [openLogic, setOpenLogic] = useState(false);

  const e = Number(entry);

  const entryMin = e ? (e - e * 0.005).toFixed(2) : "";
  const entryMax = e ? (e + e * 0.005).toFixed(2) : "";

  return (
    <div className="publisher-card">
      <div className="card-header">
        <div className="coin-name">{coin.name}</div>

        <div className="price">
          ${coin.price}
          <span className="green"> ▲{coin.change}</span>
        </div>

        <div className="date">{coin.date}</div>
      </div>

      <div className="card-divider"></div>

      <div className="form-grid">
        <div className="form-group">
          <label>My Opinion *</label>

          <div className="toggle">
            <button
              className={opinion === "long" ? "active" : ""}
              onClick={() => setOpinion("long")}
            >
              Long
            </button>

            <button
              className={opinion === "short" ? "active" : ""}
              onClick={() => setOpinion("short")}
            >
              Short
            </button>
          </div>
        </div>

        <div className="form-group">
          <label>Entry Price *</label>

          <div className="entry-row">
            <input
              placeholder="LTP"
              value={entry}
              onChange={(e) => setEntry(e.target.value)}
            />

            <RadioGroup
              row
              value={entryType}
              onChange={(e) => setEntryType(e.target.value)}
            >
              <FormControlLabel
                value="market"
                control={<Radio size="small" />}
                label="Market"
              />
              <FormControlLabel
                value="limit"
                control={<Radio size="small" />}
                label="Limit"
              />
            </RadioGroup>
          </div>

          <span className="sub-text">
            Must be within ±10% of mark price
          </span>
        </div>

        <div className="form-group">
          <label>Validity *</label>
          <input type="date" />
        </div>

        <div className="form-group">
          <label>Entry Range *</label>

          <div className="range-row">
            <input readOnly value={entryMin} placeholder="₹ 90" />
            <input readOnly value={entryMax} placeholder="₹ 100" />
          </div>

          <span className="sub-text">Entry ±0.5%</span>
        </div>

        <div className="form-group full">
          <label>Leverage *</label>

          <input
            placeholder="0X"
            value={leverage}
            onChange={(e) => setLeverage(e.target.value)}
          />

          <span className="sub-text">
            Maintain leverage above 2x
          </span>
        </div>

        <div className="form-group">
          <label>Target 1 *</label>

          <div className="percent-input">
            <input
              placeholder="₹ 100"
              value={target1}
              onChange={(e) => setTarget1(e.target.value)}
            />
            <span className="percent">0.01%</span>
          </div>

          <span className="sub-text">RR 1:1</span>
        </div>

        <div className="form-group">
          <label>Target 2 *</label>

          <div className="percent-input">
            <input
              placeholder="₹ 100"
              value={target2}
              onChange={(e) => setTarget2(e.target.value)}
            />
            <span className="percent">0.01%</span>
          </div>

          <span className="sub-text">RR 1.5:1</span>
        </div>

        <div className="form-group full">
          <label>Stoploss *</label>

          <div className="percent-input">
            <input
              placeholder="₹200"
              value={stoploss}
              onChange={(e) => setStoploss(e.target.value)}
            />
            <span className="percent">0.01%</span>
          </div>

          <span className="sub-text">
            Must be within ±20% of entry
          </span>
        </div>
      </div>

      <div className="footer-info">
        Scalping, defined as a very short-duration trade setup designed
        to capture small price movements within minutes to a few hours,
        typically targeting low percentage gains with tight stop-loss
        levels, is strictly not permitted on CryptoAnts
      </div>

      <div className="card-footer">
        <button onClick={() => setOpenLogic(true)}>LOGIC</button>
      </div>

      <LogicModal open={openLogic} onClose={() => setOpenLogic(false)} />
    </div>
  );
}

export default function Publisher() {
  const [search, setSearch] = useState("");

  const filteredCoins = dummyCoins.filter((coin) =>
    coin.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="publisher-wrapper">
      {/* SEARCH BAR */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search Coin e.g. Bitcoin"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="publisher-container">
        {filteredCoins.map((coin, index) => (
          <Card key={index} coin={coin} />
        ))}
      </div>
    </div>
  );
}